import { render } from "./cryptachi.vue?vue&type=template&id=6768b4bb"
import script from "./cryptachi.vue?vue&type=script&lang=js"
export * from "./cryptachi.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__